module.exports = __webpack_public_path__ + "static/media/Signature.033e8cd7.png";